import { Button } from '@blueprintjs/core';
import { OBJECT_STATUS } from 'Data/Enum';
import PropTypes from 'prop-types';
import styles from './StatusToggleButton.module.css';

const StatusToggleButton = ({
  currentStatus,
  onStatusToggleClicked = () => {},
  miniVersion = false,
  icon,
}) => {
  let currentStatusActive = currentStatus === OBJECT_STATUS.ACTIVE.key;
  let buttonText = currentStatusActive ? 'Mark Inactive' : 'Activate';

  return (
    <Button
      className={
        currentStatusActive ? styles.deactivate_button : styles.activate_button
      }
      small={miniVersion}
      minimal={miniVersion}
      fill={!miniVersion}
      icon={icon || (currentStatusActive && 'disable')}
      onClick={onStatusToggleClicked}>
      {!miniVersion && buttonText}
    </Button>
  );
};

StatusToggleButton.propTypes = {
  currentStatus: PropTypes.string,
  onStatusToggleClicked: PropTypes.func,
  miniVersion: PropTypes.bool,
  icon: PropTypes.string,
};

export default StatusToggleButton;
